import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      padding-bottom: 50px;
    `,
    title: css`
      font-size: 20px;
      margin-top: 8px;
    `,
    apple: css`
      width: 158px;
      height: 47px;
      background-color: #4a4a4a;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      border-radius: 4px;
      cursor: pointer;
    `,
    downloadWrap: css`
      display: flex;
      align-items: center;
    `,
    cursor: css`
      cursor: pointer;
      line-height: 1;
    `
  };
});
